import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentContainer } from '../../../../core/content-container/content-container';

@Component({
  selector: 'app-mentorship-hero',
  imports: [ContentContainer],
  templateUrl: './mentorship-hero.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MentorshipHero {}
